<script>
import Hls from "hls.js";
export default {
    name: "HlsVideo",
    props: {
        path: {
            type: String,
            required: true,
        },
        poster: {
            type: String,
            default: "",
        },
        loop: {
            type: Boolean,
            default: true,
        },
        autoplay: {
            type: Boolean,
            default: true,
        },
        mediaClasses: {
            type: String,
            default: "",
        },
        title: {
            type: String,
            default: "",
        },
    },
    data() {
        return {
            isVideoLoaded: false,
            isFinished: false,
        };
    },
    methods: {
        doPlay() {
            const video = this.$refs.video;
            if (!video) {
                console.error("компонент video не найден");
                return;
            }
            this.isFinished = false;
            if (video.canPlayType("application/vnd.apple.mpegurl")) {
                video.src = this.path;
                video.muted = true;
                video.play();
            } else if (Hls.isSupported()) {
                var hls = new Hls();
                hls.loadSource(this.path);
                hls.attachMedia(video);
                hls.on(Hls.Events.MANIFEST_PARSED, () => {
                    // console.log("МАНИФЕСТ пропарсен. Выставляем autolevel и запускаем видео...");
                    hls.startLevel = -1;
                    video?.play();
                });
                hls.on(Hls.Events.FRAG_LOADING, () => {
                    // console.log("ЗАГРУЖАЕТСЯ...", `level = ${data.frag.level}`, toRaw(data.frag));
                    video?.paused && video?.play();
                });
                hls.on(Hls.Events.FRAG_LOADED, () => {
                    // console.log("ЗАГРУЖЕН.", `level = ${data.frag.level}`);
                    video?.paused && video?.play();
                });

                hls.startLoad();
            } else {
                console.error("Этот браузер не поддерживает HLS.");
            }
        },
    },
    mounted() {
        this.doPlay();
    },
};
</script>

<template>
    <div class="hls-container" v-if="path">
        <div v-if="poster" class="hls-container__poster">
            <img data-not-lazy v-lazy-load :data-src="poster" draggable="false" :class="mediaClasses" :alt="title" />
        </div>

        <!-- загрузка на клиенте, т.к. @canplay не срабатывает при SSR. Возможно лучше @canplaythrough - полная буферизация -->

        <video
            data-not-lazy
            ref="video"
            width="100%"
            playsinline
            muted
            :loop="loop"
            :autoplay="autoplay"
            :class="[mediaClasses, { 'video--disabled': !isVideoLoaded }]"
            @ended="isFinished = true"
            draggable="false"
            @canplay="isVideoLoaded = true"></video>

        <div v-if="isFinished && !loop" @click.prevent.stop="doPlay" class="hls-container__repeat">
            <svg-icon name="arrow-circle" width="24" height="24"></svg-icon>
        </div>
    </div>
</template>

<style scoped>
.hls-container {
    position: relative;
    display: flex;
    video {
        width: 100%;
        object-fit: cover;
    }
    .video--disabled {
        opacity: 0;
        pointer-events: none;
    }
}
.hls-container__repeat {
    position: absolute;
    left: 0;
    bottom: 0;
    padding: 8px;
    opacity: 0.2;
    cursor: pointer;
    color: #fff;
    &:hover {
        opacity: 1;
    }
}
.hls-container__poster {
    position: absolute;
    inset: 0;
    z-index: -1;
    display: flex;
    overflow: hidden;

    img {
        min-height: 100%;
        min-width: 100%;
        object-fit: cover;
    }
}
</style>
